<template>
  <div class="acomodar">
    <div class="container-fluid py-3 px-2 px-md-4">
      <button class="btn btn-danger mx-2 my-2" @click="retroceder">
        <i class="bi bi-skip-backward"></i>
      </button>

      <div class="border border-1 rounded-3 p-3 mb-3">
        <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
          <i class="bi bi-folder-plus display-4 text-primary"></i>
          <div>
            <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
              ETAPA DE DOCUMENTOS
            </p>
            <p class="mb-0 tituloResaltado fs-4 fw-bold">DATOS GENERALES</p>
          </div>
        </div>
      </div>

      <!-- documento -->

      <b-modal id="modal-declaracion" title="DECLARACION DE PERSONA CON VULNERABILIDAD" size="lg" scrollable hide-footer>
        <div id="pdf-content" ref="documento" class="document-container">
          <div class="header-logo" style="text-align: right">
            <img :src="require(`../../../../assets/Empresas/${idempresa}.png`)" alt="Logo" style="width: 140px" />
          </div>

          <div class="title" style="
              text-align: center;
              font-weight: bold;
              text-decoration: underline;
              margin: 20px 0;
            ">
            DECLARACIÓN JURADA
          </div>

          <div class="content" style="text-align: justify; font-size: 13px; line-height: 1.6">
            <p>
              Yo: <strong>{{ nombre }}</strong>, de Nacionalidad:
              <strong>{{ nacionalidad }}</strong>, con DNI N° <strong>{{ dni }} </strong> en pleno proceso de
              postulación para la compañía: <strong>{{ nomEmpresa }}</strong>
            </p>

            <p>
              Declaro bajo juramento no ser parte del personal vulnerable ante
              la COVID-19, tales como:
            </p>

            <ul class="lista-vulnerabilidad" style="margin-left: 20px">
              <li>Persona con IMC mayor a 39</li>
              <li>Persona en gestación.</li>
              <li>
                No contar con enfermedades como diabetes, cáncer, hipertensión
                arterial, problemas cardiovasculares que obligue a una atención
                hospitalaria constante.
              </li>
              <li>
                Ser pacientes con patologías respiratorias crónicas, como asma,
                bronquitis crónica o enfisema pulmonar.
              </li>
            </ul>

            <p>
              Autorizo a la empresa para que - en caso sea necesario - proceda con
              la verificación de la información proporcionada a través del
              profesional de la salud que ésta designe y remitir a éste los
              antecedentes médicos de corresponder por estar contenido en el
              Sistema de Gestión de Seguridad y Salud en el Trabajo.
            </p>

            <p>
              El presente documento se suscribe con la finalidad de proteger y
              promover la contratación de manera responsable ante el inminente
              avance del COVID-19 y en conformidad a nuestro Plan de Vigilancia
              para la Prevención y Control de la COVID-19.
            </p>

            <p style="margin-top: 30px">
              Se suscribe la Declaración Jurada el {{ fechaActual }}
            </p>

               <div class="firma-container d-flex" style="margin-top: 60px;">
                <div class="ms-auto text-center" style="width: 300px;">
                  <p>
                    <strong>
                      {{ nombre }} ( {{ dni }} ) <br /> 
                      Firmado y aceptado digitalmente <br />
                      {{ fechaActual }}
                    </strong>
                  </p>
                </div>
              </div>
          </div>
        </div>
        <div class="text-center">
             <b-button class="mt-3 text-center" variant="success" block @click="descargarPDF('004')">He leído, comprendo y acepto la Declaración Jurada y las responsabilidades legales que implica.</b-button>
        </div>
     
      </b-modal>

      

       <!-- <b-modal id="modal-verificacion" title="AUTORIZACIÓN DE VERIFICACIÓN" size="lg" scrollable hide-footer>
        <div id="pdf-content" ref="documento" class="document-container">
          <div class="header-logo" style="text-align: right">
            <img :src="require(`../../../../assets/Empresas/${idempresa}.png`)" alt="Logo" style="width: 140px" />
          </div>

          <div class="title" style="
              text-align: center;
              font-weight: bold;
              text-decoration: underline;
              margin: 20px 0;
            ">
            AUTORIZACIÓN DE VERIFICACIÓN
          </div>

          <div class="content" style="text-align: justify; font-size: 13px; line-height: 1.6">
            <p>
              Mediante el presente documento yo: <strong>{{ nombre }}</strong>, de Nacionalidad:
              <strong>{{ nacionalidad }}</strong>, identificado con DNI : <strong>{{ dni }} </strong> autorizo expresamente 
              y en forma irrevocable el descuento por planilla respecto a las verificaciones de antecedentes policiales, 
              penales y judiciales, por el monto de S/. 15.00 soles, el cual se visualizará en la primera boleta de pago.
            </p>

            <br>
            <p>
              <strong>People Outsourcing:</strong> 
            </p>

            <ol class="lista-vulnerabilidad" style="margin-left: 20px">
              <li>Garantiza la confidencialidad y seguridad de los datos proporcionados por el postulante.</li>
              <li>Reconoce y garantiza el derecho del postulante de acceder, aclarar y/o excluir datos que considere 
                de carácter sensible.</li>
              <li>
                Reconoce y garantiza el derecho de las personas de solicitar su eliminación de las bases de datos, al
                 término de cualquier vínculo: laboral, comercial, administrativo, operacional u otro, el que se 
                 realizará observando lo dispuesto en el D.S. 003-2013-JUS Reglamento de la Ley 29733, Ley de Protección
                  de Datos Personales..
              </li>              
            </ol>            

            <p style="margin-top: 30px">
              Miflores, {{ fechaActual }}
            </p>

               <div class="firma-container d-flex" style="margin-top: 60px;">
                <div class="ms-auto text-center" style="width: 300px;">
                  <p>
                    <strong>
                      {{ nombre }} ( {{ dni }} ) <br /> 
                      Firmado y aceptado digitalmente <br />
                      {{ fechaActual }}
                    </strong>
                  </p>
                </div>
              </div>
          </div>
        </div>
        <div class="text-center">
             <b-button class="mt-3 text-center" variant="success" block @click="descargarPDF('008')">He leído, comprendo y acepto la autorización de verificación y las responsabilidades legales que implica.</b-button>
        </div>
     
      </b-modal> -->

      <div class="border border-1 pt-2 pb-1 mt-2 mx-2">
        <form action="">
          <div v-if="permisoVisualizador != 6" class="row gx-2 px-2 mt-3">
            <!-- <h4
            v-if="documentoEscoger.length > 0"
            class="mt-2 titulo mb-3 text-decoration-underline"
          >
            Documentos:
          </h4> -->

            <div v-show="escoger.parCorrelativo == '004' || escoger.parCorrelativo == '009'" v-for="escoger in documentoEscoger" :key="escoger.id"
              class="col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div v-if="escoger.parCorrelativo == '004'" class="shadow-lg p-3 mb-3 bg-white rounded">
                <div class="text-center tamaño">
                  {{ escoger.parDescripcion }}
                </div>
                <div  class="text-center">
                 
                    <b-button class="mt-2" @click="$bvModal.show('modal-declaracion')" variant="primary">
                    Ver Declaración Jurada
                  </b-button>
                             
                </div>

              </div>

              <!-- <div v-if="escoger.parCorrelativo == '009'" class="shadow-lg p-3 mb-3 bg-white rounded">
                <div class="text-center tamaño">
                  {{ escoger.parDescripcion }}
                </div>
                <div  class="text-center">
                 
                    <b-button class="mt-2" @click="$bvModal.show('modal-verificacion')" variant="primary">
                    Ver autorización de verificación
                  </b-button>
                             
                </div>

              </div> -->
            </div>
          </div>
        </form>

        <div class="mx-2">
          <div class="d-flex justify-content-end ms-4 mb-4">
            <label for="" class="mt-4 tamaño2"> Buscar:</label>
            <input class="form-control form-control-lg ms-4 mt-2 tamaño2 tamañofiltrado" type="text"
              placeholder="Tipo de documento" aria-label=".form-control-lg example" v-model="filterField"
              :class="{ 'w-100 mt-3': isMobile, 'w-25': !isMobile }" />
          </div>

          <!-- tabla -->
          <!-- tabla -->
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="bg-solimano-table text-white text-center tamaño2">
                  <th>ID</th>
                  <th scope="col">TIPO DOCUMENTO</th>
                  <th scope="col">DOCUMENTO</th>
                  <th v-if="!isMobile" scope="col">PREVISUALIZACION</th>
                  <th>AUDITORIA</th>
                  <th v-if="
                    permisoVisualizador == 2 ||
                    permisoVisualizador == 10 ||
                    permisoVisualizador == 18
                  ">
                    ELIMINAR
                  </th>
                </tr>
              </thead>

              <!-- SPINNER DE CARGA -->
              <tbody v-if="loading">
                <tr>
                  <td colspan="6" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status"></div>
                    <p class="mt-2 text-muted fw-bold">
                      Cargando documentos...
                    </p>
                  </td>
                </tr>
              </tbody>

              <!-- CUANDO YA CARGO LOS DATOS -->
              <tbody v-else>
                <tr  v-for="doc in paginatedDocuments" :key="doc.idDocumento" class="tamaño2 align-middle">
                  <td  class="text-center">{{ doc.idDocumento }} </td>

                  <!-- TIPO DOCUMENTO CON ICONO -->
                  <td  class="text-center">
                    <i class="bi bi-folder2-open"></i>

                    {{ doc.nomTipoDocumento }}
                  </td>

                  <!-- DESCARGA -->
                  <td  class="text-center">
                    <a :href="url + doc.docAdjunto.slice(54)" target="_blank" class="btn btn-success btn-sm me-1"
                      title="Descargar">
                      <i class="bi bi-download"></i>
                    </a>
                  </td>

                  <!-- VISTA PREVIA -->
                  <td v-if="!isMobile" class="text-center">
                    <button class="btn btn-primary btn-sm" @mouseover="
                      doc.docAdjunto.slice(-3) === 'pdf'
                        ? openModal(url + doc.docAdjunto.slice(54))
                        : openModal2(url + doc.docAdjunto.slice(54))
                      " title="Vista previa">
                      <i class="bi bi-eye-fill"></i>
                    </button>

                    <!-- modal pdf -->
                    <div class="modal" v-if="showModal" @mouseout="closeModal">
                      <div class="modal-content">
                        <object :data="currentUrl" type="application/pdf" class="w-100 h-100"></object>
                      </div>
                    </div>

                    <div class="modal" v-if="showModal2" @mouseout="closeModal2">
                      <div class="modal-content">
                        <img :src="currentUrl2" class="w-100 h-100" />
                      </div>
                    </div>
                  </td>

                  <!-- AUDITORIA CON ICONO -->
                  <td  class="text-center">
                    <i class="bi bi-person-check-fill" :class="{
                      'text-success': doc.audCrea
                        .toLowerCase()
                        .includes('completo'),
                      'text-warning': doc.audCrea
                        .toLowerCase()
                        .includes('pendiente'),
                      'text-danger': doc.audCrea
                        .toLowerCase()
                        .includes('error'),
                    }"></i>
                    {{ doc.audCrea }}
                  </td>

                  <!-- ELIMINAR -->
                  <td v-if="
                    permisoVisualizador == 2 ||
                    permisoVisualizador == 10 ||
                    permisoVisualizador == 18
                  " class="text-center">
                    <button class="btn btn-danger btn-sm" @click="Eliminar(doc.idDocumento)" title="Eliminar documento">
                      <i class="bi bi-trash3-fill"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- PAGINACIÓN -->
            <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
              <button class="btn btn-outline-primary btn-sm" @click="goToPage(1)" :disabled="currentPage === 1">
                <i class="bi bi-chevron-double-left"></i>
              </button>
              <button class="btn btn-outline-primary btn-sm" @click="previousPage" :disabled="currentPage === 1">
                <i class="bi bi-chevron-left"></i>
              </button>
              <span class="pagination-info fw-bold">
                Página {{ currentPage }} de {{ totalPages }}
              </span>
              <button class="btn btn-outline-primary btn-sm" @click="nextPage" :disabled="currentPage === totalPages">
                <i class="bi bi-chevron-right"></i>
              </button>
              <button class="btn btn-outline-primary btn-sm" @click="goToPage(totalPages)"
                :disabled="currentPage === totalPages">
                <i class="bi bi-chevron-double-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import html2pdf from "html2pdf.js";
// import pdfjsWrapper from 'vue-pdf/src/pdfjsWrapper';
// import PDFJS from 'pdfjs-dist';
// import * as PDFJS from 'pdfjs-dist/build/pdf';
// import 'pdfjs-dist/build/pdf.worker'; // Importar el archivo pdf.worker.js
// import 'pdfjs-dist/build/pdf.worker.entry';

// PDFJS.GlobalWorkerOptions.workerPort = () => new PDFJS.PDFWorker({});

export default {
  name: "SolimanologDatosDocumentos",

  data() {
    return {
      vacio: "",
      loading: false,
      currentPage: 1,
      pageSize: 6,
      filterField: "",
      url: "https://apitopas.gruposolimano.com.pe/Documentos/Postulacion/",
      cerrarTable1: true,
      cerrarTable2: false,

      tipoDoc: "",
      idSolxPostulante: "",
      idUsuario: "",
      isdisabled: false,
      // retro: false,
      // avanzar: true,

      documento: [],
      documentoEscoger: [],
      docPendiente: "",
      selectedFile: null,
      permisoVisualizador: null,
      magnifierPosition: "0px 0px", // Agrega la propiedad magnifierPosition y su valor inicial
      showModal: false,
      showModal2: false,
      currentUrl: "",
      currentUrl2: "",

      isMobile: false,

      //
      idempresa: "1",
      nombre: "",
      dni: "",
      nacionalidad: "",
      nomEmpresa: "",
    };
  },

  async mounted() {
    this.permisoVisualizador = localStorage.getItem("idPerfil");

    this.idSolxPostulante = this.$route.params.idSol;
    const humanos = localStorage.getItem("userId");
    this.idUsuario = humanos;
    console.log(this.idUsuario);

    let listado = await this.axios.get(
      `Documentos/OpcDocumentos?idSolxPostulant=${this.$route.params.idSol}&idUsuario=${humanos}`
    );

    this.documentoEscoger = listado.data;
    console.log('asssss',this.documentoEscoger);

    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
  },

  created() {
    this.getAttributes();
    this.atrributesGetters();
    this.cambiarEstadoNavbar();
    this.UsuarioData();
  },

  computed: {

    documentosFiltrados004() {
    return this.documento.filter(doc => doc.tipoDoc == '004');
  },

  // 2. Pagina SOLO sobre los documentos ya filtrados
  paginatedDocuments() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    return this.documentosFiltrados004.slice(start, end);
  },

  // 3. Importante: Ajusta el total de páginas según la cantidad de documentos '004'
  totalPages() {
    const total = Math.ceil(this.documentosFiltrados004.length / this.pageSize);
    return total === 0 ? 1 : total;
  },
    // totalPages() {
    //   return Math.ceil(this.documento.length / this.pageSize);
    // },
    // paginatedDocuments() {
    //   const start = (this.currentPage - 1) * this.pageSize;
    //   const end = start + this.pageSize;
    //   return this.documento.slice(start, end);
    // },

    fechaActual() {
      const meses = [
        "enero", "febrero", "marzo", "abril", "mayo", "junio",
        "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
      ];
      const f = new Date();
      const anio = 2026; // Año fijo según tu requerimiento

      // Extraer hora y minutos
      const horas = String(f.getHours()).padStart(2, '0');
      const minutos = String(f.getMinutes()).padStart(2, '0');

      // Formato: 17 de febrero del 2026 a las 11:04
      return `${f.getDate()} de ${meses[f.getMonth()]} del ${anio} a las ${horas}:${minutos}`;
    },
  },

  methods: {
    UsuarioData() {
      this.axios
        .get("Contrato/ObtenerDatosContrato/" + this.$route.params.idSol)
        .then((r) => {
          console.log("data", r.data);

          this.nombre =
            r.data[0].posNombre + ' ' +
            r.data[0].posApellidoPaterno + ' ' +
            r.data[0].posApellidoMaterno;

          this.sisPensiones = r.data[0].sisPensiones;
          this.nomEmpresa = r.data[0].nomEmpresa;
          this.dni = r.data[0].posNroDocumento;
          this.nacionalidad = r.data[0].nomNacionalidad;
          this.idempresa = r.data[0].idEmpresa;
        });
    },

    goToPage(page) {
      this.currentPage = page;
    },
    previousPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },

    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

    checkIfMobile() {
      this.isMobile = window.innerWidth <= 768; // Ajusta el ancho según tus necesidades
    },
    openModal(url) {
      console.log(url);
      this.showModal = true;
      this.currentUrl = url;
    },

    closeModal() {
      this.showModal = false;
      this.currentUrl = "";
    },

    openModal2(url) {
      console.log(url);
      this.showModal2 = true;
      this.currentUrl2 = url;
    },

    closeModal2() {
      this.showModal2 = false;
      this.currentUrl2 = "";
    },
    async atrributesGetters() {
      const humanos = localStorage.getItem("userId");
      console.log(humanos);
      let documentoPendiente = await this.axios.get(
        `Documentos/ValidarDocumentos?idSolxPostulante=${this.$route.params.idSol}&idUsuario=${humanos}`
      );
      this.docPendiente = documentoPendiente.data;
      console.log(documentoPendiente.data);
    },

    async getAttributes() {
      this.loading = true;
      const humanos = localStorage.getItem("userId");
      let doc = await this.axios.get(
        `Documentos/ListarDocxUser?idSolxPostulante=${this.$route.params.idSol}&idUser=${humanos}`
      );
      this.documento = doc.data;
      console.log(doc.data);
      this.loading = false;
    },

    retroceder() {
      window.history.back();
    },

    onFileSelected(event) {
      
      this.selectedFile = event.target.files[0];
      
       console.log(this.selectedFile.name)
    },

    onUpload(event) {
      if(event != '004' ){
      this.tipoDoc = event.target.value;
      }else{
      this.tipoDoc = event
      }
      //  console.log('kk' ,  event , this.tipoDoc);

      const fd = new FormData();
      fd.append("Archivo", this.selectedFile);
      fd.append("tipoDoc", this.tipoDoc);
      fd.append("idSolxPostulante", this.idSolxPostulante);
      fd.append("IdUsuario", this.idUsuario);

      this.axios
        .post("Documentos/InsertarDocumento", fd)
        .then((r) => {
          console.log(r.data);
          console.log(this.tipoDoc, this.idSolxPostulante, this.idUsuario);

          if (r.data) {
            this.tipoDoc = "";
            let timerInterval;
            Swal.fire({
              title: "¡Espere un momento, no cerrar la pantalla!",
              html: "<strong>Cargando archivo <b></b> ...</strong>",
              timer: 2000,
              timerProgressBar: true,
              didOpen: () => {
                Swal.showLoading();
                const b = Swal.getHtmlContainer().querySelector("b");
                timerInterval = setInterval(() => {
                  b.textContent = Swal.getTimerLeft();
                }, 450);
              },
              willClose: () => {
                clearInterval(timerInterval);
                this.$bvModal.hide('modal-declaracion');
              },
            }).then((result) => {
              /* Read more about handling dismissals below */
              if (result.dismiss === Swal.DismissReason.timer) {
                this.getAttributes();
                this.atrributesGetters();
              }
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    Eliminar(id) {
      Swal.fire({
        title: "¿Eliminar Documento?",
        // text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si",
        cancelButtonText: "NO",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire("Eliminado!", "con éxito.", "success");
          this.axios.delete("Documentos/Eliminar/" + id).then((r) => {
            console.log(r.data);
            this.getAttributes();
            this.atrributesGetters();
          });
        }
      });
    },

    pdfAbrir(mostrarPdf) {
      console.log(mostrarPdf);
      // var URL =  `file:///C:/`;

      // window.open(URL ,null );

      // console.log(URL)
    },

    async descargarPDF(codigo) {
          const element = this.$refs.documento;
          
          const opt = {
            margin: [1, 1, 1, 1],
            filename: 'declaracion.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: { unit: 'cm', format: 'a4', orientation: 'portrait' }
          };

          try {
            // Usamos la sintaxis de Worker para asegurar que outputBlob funcione
            const pdfBlob = await html2pdf()
              .set(opt)
              .from(element)
              .output('blob'); // Aquí está el cambio clave: .output('blob')

            // Ahora lo convertimos a FILE para tu variable selectedFile
            this.selectedFile = new File([pdfBlob], "Declaracion_Jurada.pdf", {
              type: "application/pdf",
              lastModified: new Date().getTime()
            });

            console.log("Archivo guardado con éxito en this.selectedFile" , this.selectedFile);
            // alert("¡PDF listo para cargar!");

            // Aquí ya puedes llamar a tu función de subir si quieres
             this.onUpload(codigo);

          } catch (error) {
            console.error("Error al procesar el PDF:", error);
            // alert("Hubo un problema al generar el archivo.");
          }

    },
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 1%;
  margin-bottom: 1%;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left: 1%;
  margin-right: 1%;
  height: auto;
  padding-bottom: 20px;
  border-radius: 10px 10px 10px 10px;
  overflow-x: hidden;
  overflow-y: none;
}

.textos {
  display: flex;
  justify-content: center;
  align-items: center;
}

.tamaño {
  font-size: 0.65rem;

  font-weight: 700;
  color: #002c5d;
}

.tamaño2 {
  font-size: 0.65rem;
}

.titulo {
  color: #0080c8;
  text-decoration: underline;
}

.titulo2 {
  color: #0080c8;
  font-weight: 600;
}

.bg-solimano {
  border-color: #0080c8;
  border-width: 2px;
}

.bg-solimano-table {
  background: #0080c8;
}

.pdfview {
  width: 500px;
  height: 400px;
}

.magnifier {
  position: absolute;
  border: 1px solid black;
  pointer-events: none;
}

.modal {
  position: fixed;
  /* top: 0;
  left: 0; */
  width: 100%;
  height: 100%;
  background-color: rgba(250, 250, 250, 0);
  /* Fondo transparente */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  width: 30%;
  height: 70%;
  background-color: #fff;
}

.modal-content object {
  width: 100%;
  height: 100%;
}

.tituloColorMas {
  /* color: #002c5d; */
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.tamañofiltrado {
  font-size: 0.65rem;
}

/* pendientes de documentos pdf */

.document-container {
  background-color: white;
  padding: 1cm;
  /* Margen interno de la hoja */
  margin: 0 auto;
  /* Centrar la hoja en el modal */
  width: 100%;
  /* Que se adapte al ancho del modal-lg */
  max-width: 21cm;
  /* Ancho máximo de una hoja A4 */
  min-height: 18.7cm;
  /* Altura mínima de una hoja A4 */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  /* Sombrita para que se note el papel */
  font-family: Arial, sans-serif;
  color: black;
}

.header-logo {
  text-align: right;
  margin-bottom: 10px;
}

.header-logo img {
  width: 120px;
}

.title {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  text-decoration: underline;
  margin-bottom: 20px;
}

.content p {
  text-align: justify;
  margin-bottom: 5px;
}

.lista-vulnerabilidad {
  margin-left: 20px;
  margin-bottom: 10px;
}

.firma-container {
  margin-top: 100px;
}

.linea-firma {
  width: 250px;
  border-top: 1px solid black;
  margin: 0 auto 5px auto;
}

.btn-download {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
</style>
